module.exports = __webpack_public_path__ + "static/media/cedula_dorso.daef2fe9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/user/cedula_dorso.jpg
// module id = 346
// module chunks = 0